$(document).ready(function() {

  $('.mobile-facets__open-wrapper').find('.mobile-facets__open').removeClass('click-mobile-facets__open');

  $(document).on('mouseover', '.megamenu-dropdown-items .megamenu-items', function() {
      $('.megamenu-dropdown-items .megamenu-items').removeClass('show');
      $(this).addClass('show');
  });

  $(document).on('mouseover', '.has-megmenu', function() {
      $('.list-menu-item').find('.megamenu-dropdown-items .megamenu-items').removeClass('show');
      $(this).closest('.list-menu-item').find('.megamenu-dropdown-items .megamenu-items:first').addClass('show');
  });
  
  $(document).on('mouseover', '.list-menu-item', function() {
    $('.list-menu-item').removeClass('add_hover');
    $(this).addClass('add_hover');
  });

  $(document).on('mouseout', '.list-menu-item', function(e) {
      $(this).removeClass('add_hover');
      $('.megamenu-items').removeClass('show');
  });

  $(document).on('click', '.clear-all-text', function() {
      $('.cart-drawer').find('.cart-drawer__empty-content').addClass('active-cart-empty-content');
  });

   $(document).on('click', '.facets_questions', function() {
      $('.facets_questions').addClass('active-facets_questions');
  });

   $(document).on('click', '.facets-container .facets__summary', function() {
      $('.facets-label').addClass('active-facets-label');
  });

  $('cart-all-clear').on('keydown', function(event) {
    if (event.key === 'Enter') {
        // Prevent default action (optional)
        event.preventDefault();
        // Trigger the click event to clear all
        $(this).click();
    }
  });

  $(document).on('click', '.clear-all-text', function() {
     $('.cart-drawer__footer').addClass('cart-drawer__footer-empty');
  });

   $(document).on('click', '.custom_sort_sctive', function() {
     $(this).toggleClass('custom_sort_sctive-active');
  });

 $('body').on('keyup', '.list-menu-item', function(e) {
   $('.list-menu-item').removeClass('add_hover');
    if(e.keyCode == 9 || (e.shiftKey && e.keyCode == 9)){
      $(this).addClass('add_hover');
     if($(this).find('.megamenu-dropdown-items .megamenu-items.show').length <= 0){
        $(this).find('.megamenu-dropdown-items .megamenu-items').removeClass('show');
        $(this).find('.megamenu-dropdown-items .megamenu-items:first').addClass('show');
     }
    }
  });
  
  $('body').on('keyup', '.megamenu-items', function(e) {
    if($(e.target).hasClass('menu-heading')){
      $('.megamenu-items').removeClass('show');
    }
    if ((e.keyCode == 9 || (e.shiftKey && e.keyCode == 9)) && $(e.target).hasClass('menu-heading')) {
      $(this).addClass('show');
      $(e.target).parents('.megamenu-items').addClass("show");
    }
  });

  $(document).on('keydown', '.quick-view-icon', function() {
    if (e.key === 'Enter' || e.key === ' ') { // Handle Enter and Space keys
      $(this).click(); // Trigger the click event
    }
  });

 // When a product card is focused
  $(document).on('focus', '.product-card-wrapper', function() {
      $(this).addClass('focus');
  });

 $(document).on('blur', '.product-card-wrapper', function() {
  // Optionally, you can remove the class when the product card loses focus
      $(this).removeClass('focus');
  });

 $('.button-add-to-cart.button-add-to-cart_main').on('keypress', function(event) {
    // Check if the pressed key is "Enter" (key code 13)
    if (event.which === 13) {
        // Trigger the click event on the button
       $(this).click();
       $('.drawer').addClass('active');
    }
  });

  $('.custom-checkbox').on('keydown', function(event) {
    if (event.key === 'Enter') {
        // Prevent default action (optional)
        event.preventDefault();
        // Toggle the checkbox state
        $(this).prop('checked', !$(this).prop('checked'));
    }
  });

  // Add 'filled' class on focus if the input is not empty

  $(document).on('focus', '.field__input, .newsletter-field-input, .text-area-field-input', function() {
    var $this = $(this);
    checkInputFilled($this);
  });

  // Remove 'filled' class on blur if the input is empty

  $(document).on('blur', '.field__input, .newsletter-field-input, .text-area-field-input', function() {
    var $this = $(this);
    checkInputFilled($this);
  });

  $(document).on('input', '.field__input, .newsletter-field-input, .text-area-field-input', function() {
  // Add 'filled' class on input if the field is filled
    var $this = $(this);
    checkInputFilled($this);
  });

  $(document).on('keydown', '.collection-list-card-wrapper', function() {
    if (event.key === 'Enter') {
      var url = $(this).data('url');
      if (url) {
          window.location.href = url;
      }
    }
  });

  $(document).on('focus', '.quantity__input', function() {
      $(this).closest('quantity-input').addClass('focus-quantity');
  });

  $(document).on('blur', '.quantity__input', function() {
      $(this).closest('quantity-input').removeClass('focus-quantity');
  });

  $(document).on('mouseenter', '.quantity__input', function() {
      $(this).addClass('hover-quantity');
  });

  $(document).on('mouseleave', '.quantity__input', function() {
      $(this).removeClass('hover-quantity');
  });

  $(document).on('focus', '.contact-us-form-section .field-wrapper  .text-area-field-input', function() {
      $(this).addClass('focus');
  });

  $(document).on('blur', '.contact-us-form-section .field-wrapper  .text-area-field-input', function() {
      $(this).removeClass('focus');
  });

  $(document).on('click', '.mobile-facets__open', function() {
   $(this).addClass('click-mobile-facets__open');
 });

  $(document).on('click', '.mobile-facets__close', function() {
   $('.mobile-facets__open-wrapper').find('.mobile-facets__open').removeClass('click-mobile-facets__open');
 });

 


});


// $(document).ready(function() {
//     var stickyElement = $('.tab-heading-wrapper');

//     $(window).scroll(function() {
//         var scrollTop = $(this).scrollTop();
//         var stickyOffset = stickyElement.offset().top; // Get the offset of the sticky element

//         if (scrollTop >= stickyOffset) {
//             stickyElement.addClass('sticky-active'); // Add class when sticky
//         } else {
//             stickyElement.removeClass('sticky-active'); // Remove class when not sticky
//         }
//     });
// });


  $(document).ready(function() {
    $('.facets-label').on('click', function() {
      // Toggle the 'open' attribute on the parent element
      var $disclosure = $(this).closest('.facets__disclosure-vertical');
      $disclosure.attr('open', !$disclosure.attr('open'));
      
      // Rotate the SVG
      if ($disclosure.attr('open')) {
          $disclosure.find('svg').css('transform', 'rotate(180deg)');
      } else {
          $disclosure.find('svg').css('transform', 'rotate(0deg)');
      }
    });
  });

  $(document).on('click', '.mobile-facets__summary', function() {
    var $svg = $(this).find('svg');
    // Toggle rotation based on current state
    if ($svg.css('transform') === 'none' || $svg.css('transform') === 'matrix(1, 0, 0, 1, 0, 0)') {
      // Rotate 180 degrees if not already rotated
      $svg.css('transform', 'rotate(180deg)');
    } else {
      // Reset rotation
      $svg.css('transform', 'rotate(0deg)');
    }
  });
  
  function isTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  }
  
  function checkInputFilled($input) {
    if ($input.val().trim() !== '') {
      $input.addClass('filled');
    } else {
      $input.removeClass('filled');
    }
  }

  $(document).ready(function() {
    if (isTouchDevice()) {
      $('.quick-icon-wrapper').addClass('touchscreen-device');
    }
  });

   $(document).ready(function(){
    $('.icon-checkmark').hover(function() {
        $(this).siblings('input[type=checkbox]').css('background', '#2A472B'); // Change to desired color
    }, function() {
        $(this).siblings('input[type=checkbox]').css('background', ''); // Reset to original color
    });
  });

 $(document).ready(function () {
    $(document).on('click', '.question-wrapper ', function() {
      if ($('.answer-wrapper').is(':visible')) {
         $('.answer-wrapper').slideUp(300);
         $('.faq-updown-icon').removeClass('faq-updown-icon-show');
         $('.accordion-row').removeClass('active');
      }
      if ($(this).next('.answer-wrapper').is(':visible')) 
      {
        $(this).next('.answer-wrapper').slideUp(300);
        $(this).find('.faq-updown-icon').removeClass('faq-updown-icon-show');
         $(this).closest('.accordion-row').removeClass('active');
      } 
      else
      {
        $(this).next('.answer-wrapper').slideDown(300);
        $(this).find('.faq-updown-icon').addClass('faq-updown-icon-show');
        $(this).closest('.accordion-row').addClass('active');
      }
  });

   $('body').on('click', '.facets_questions', function(e) {
     e.preventDefault();
     var _this = $(this);
      if ($(this).next('.facets_answers').is(':visible')) {
        $(this).next('.facets_answers').slideUp(200);
        $(this).closest('.facets__disclosure-vertical').removeAttr('open');
      } else {
        setTimeout(function(){
          _this.closest('.facets__disclosure-vertical').attr('open', "open");
        },250);
        $(this).next('.facets_answers').slideDown(200);
      }
  });

   $('body').on("click",".custom_sort_sctive",function(e){
     e.preventDefault();
    if ($(this).closest('.display_custom_sort').find('.custom_select_drop_down').is(':visible')){
      $(this).closest('.display_custom_sort').find('.custom_select_drop_down').slideUp(300);
    }else{ 
     $(this).closest('.display_custom_sort').find('.custom_select_drop_down').slideDown(300);
    }
   });
   
   $(document).on('click', '.custom-facet-accordion summary', function() {
     var _this = $(this);
    if ($(this).next('.mobile-facets__submenu').is(':visible')){
      $(this).removeClass('active');
      $(this).next('.mobile-facets__submenu').slideUp(300);
    }else{
      $(this).next('.mobile-facets__submenu').slideDown(300);
      setTimeout(function(){
        _this.addClass('active');
      },350);
    }
  });

  $(document).on('click', '.mobile-facets__close', function() {
    var clo = $(this);
     setTimeout(function(){
        clo.closest('.mobile-facets__disclosure').removeClass('menu-opening');
    }, 40);
    clo.closest('.mobile-facets__disclosure').removeClass('displayfacet-data');
    setTimeout(function(){
       clo.closest('.mobile-facets__disclosure').removeClass('displayfacet-overlay');
       clo.closest('.mobile-facets__disclosure').removeAttr('open');
    }, 400);
    $('body').removeClass("overflow-hidden-mobile");
  });

  //collection page get image color
  var $image = $('.collection-hero__image-container img');
  if ($image.length) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var img = new Image();
    img.crossOrigin = 'Anonymous';

    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;
      var r = 0, g = 0, b = 0, count = 0;
      for (var i = 0; i < data.length; i += 4) {
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        count++;
      }
      r = Math.floor(r / count);
      g = Math.floor(g / count);
      b = Math.floor(b / count);
      var rgbColor = 'rgb(' + r + ',' + g + ',' + b + ')';
      $('.collection-hero-banner-svg path').css('fill', rgbColor);
    };
    img.src = $image.attr('src');
  }
   
});


// $(window).scroll(function() {
//     var scrollPos = $(window).scrollTop(); // Get current scroll position
//     var tabSectionOffset = $('.product-tab-section').offset().top; // Top offset of product-tab-section
//     var tabSectionHeight = $('.product-tab-section').outerHeight(); // Height of product-tab-section
//     var tabSectionBottom = tabSectionOffset + tabSectionHeight; // Bottom position of product-tab-section

//     // Apply sticky behavior for both mobile and desktop
//     if (scrollPos >= tabSectionOffset && scrollPos <= tabSectionBottom) {
//         $('.tab-heading-wrapper').addClass('sticky-active');
//     } else {
//         $('.tab-heading-wrapper').removeClass('sticky-active');
//     }
// });



// -------------------------------------------collection filter ADA -------------------------------------------------------------------

// $(document).ready(function() {
//   // Variable to keep track of the currently open disclosure
//   var $currentOpenDisclosure = null;

//   $('.facets-label').on('click keydown', function(event) {
//     // Check for click or Space bar key
//     if (event.type === 'click' || (event.type === 'keydown' && event.key === ' ')) {
//       event.preventDefault(); // Prevent default action for space key

//       // Call the function to toggle the accordion
//       toggleAccordion($(this));
//     }
//   });

//   function toggleAccordion($label) {
//     // Toggle the 'open' attribute on the parent element
//     var $disclosure = $label.closest('.facets__disclosure-vertical');
//     var isOpen = $disclosure.attr('open') === 'true'; // Check if 'open' is set to true

//     // Close the currently open disclosure if it's not the same as the one being toggled
//     if ($currentOpenDisclosure && $currentOpenDisclosure[0] !== $disclosure[0]) {
//       // Close the currently open disclosure
//       $currentOpenDisclosure.attr('open', false);
//       $currentOpenDisclosure.find('.facets_answers').removeClass('show'); // Hide facets_answers by removing class
//     }

//     // Toggle the value of the 'open' attribute for the clicked disclosure
//     $disclosure.attr('open', !isOpen);

//     // Show or hide the facets_answers using class
//     var $facetsAnswers = $disclosure.find('.facets_answers'); // Adjust selector based on your HTML structure
//     if (!isOpen) {
//       $facetsAnswers.addClass('show'); // Show facets_answers by adding class
//       $currentOpenDisclosure = $disclosure; // Update the current open disclosure
//     } else {
//       $facetsAnswers.removeClass('show'); // Hide facets_answers by removing class
//       $currentOpenDisclosure = null; // Reset the current open disclosure
//     }
//   }
// });


// $(document).ready(function() {
  
//   // Variable to keep track of the currently open disclosure
//   var $currentOpenDisclosure = null;

//   $('.facets-label').on('click keydown', function(event) {
//     // Check for click, Enter key, or Space bar
//        if (event.type === 'click' || (event.type === 'keydown' && event.key === ' ')) {

//       event.preventDefault(); // Prevent default action for space and enter keys

//       // Toggle the 'open' attribute on the parent element
//       var $disclosure = $(this).closest('.facets__disclosure-vertical');
//       var isOpen = $disclosure.attr('open') === 'true'; // Check if 'open' is set to true

//       // Close the currently open disclosure if it's not the same as the one being toggled
//       if ($currentOpenDisclosure && $currentOpenDisclosure[0] !== $disclosure[0]) {
//         // Close the currently open disclosure
//         $currentOpenDisclosure.attr('open', false);
//         $currentOpenDisclosure.find('.facets_answers').css('display', 'none'); // Hide facets_answers
//         $currentOpenDisclosure.find('svg').css('transform', 'rotate(0deg)'); // Reset SVG rotation
//       }

//       // Toggle the value of the 'open' attribute for the clicked disclosure
//       $disclosure.attr('open', !isOpen);

//       // Show or hide the facets_answers using display: block
//       var $facetsAnswers = $disclosure.find('.facets_answers'); // Adjust selector based on your HTML structure
//       if (!isOpen) {
//         $facetsAnswers.css('display', 'block'); // Show facets_answers
//         $disclosure.find('svg').css('transform', 'rotate(180deg)'); // Rotate SVG
//         $currentOpenDisclosure = $disclosure; // Update the current open disclosure
//       } else {
//         $facetsAnswers.css('display', 'none'); // Hide facets_answers
//         $disclosure.find('svg').css('transform', 'rotate(0deg)'); // Reset SVG rotation
//         $currentOpenDisclosure = null; // Reset the current open disclosure
//       }
//     }
//   });
// });

// $(document).ready(function() {
//   $('.add-to-cart-button').on('click', function(event) {
//     event.preventDefault(); // Prevents the default submit action

//     // Adding classes to specified elements when the button is clicked
//     $('.main-cart-drawer-note').addClass('open-menu');
//     $('.drawer').addClass('animate active-both-drawer not-empty-drawer add-cart-drawer active');
//     $('.cart-drawer__overlay').addClass('active-cart-open-overlay');
//     $('.cart-drawer').addClass('main-cart-active');
//   });
// });
